const CustomProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  navigating = false;

  init() {
    const url = this.getAttribute("data-url");
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        this.innerHTML = text;
        this.classList.remove("loading");

        setTimeout(() => {
          const title = this.querySelector(
            ".pdp-custom-recommendations__header-title"
          );
          const titleAttr = this.getAttribute("data-title");
          if (title && titleAttr) {
            title.innerText = titleAttr;
          }

          const wrapper = this.querySelector(
            ".pdp-custom-recommendations__wrapper"
          );
          if (wrapper) {
            wrapper.addEventListener(
              "touchstart",
              this.onTouchStart.bind(this)
            );
            wrapper.addEventListener(
              "touchend",
              this.onTouchEnd.bind(this),
              false
            );
          }

          const buttons = this.querySelectorAll(
            ".pdp-custom-recommendations__header-button"
          );
          if (buttons) {
            buttons.forEach((button) => {
              button.addEventListener(
                "click",
                this.onNavigateButtonClick.bind(this)
              );
            });
          }
        }, 100);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleGesture() {
    if (Math.abs(this.touchendX - this.touchstartX) > 50) {
      if (this.touchendX < this.touchstartX) {
        this.navigate(true);
      } else if (this.touchendX > this.touchstartX) {
        this.navigate(false);
      }
    }
  }

  onTouchStart(event) {
    this.touchstartX = event.changedTouches[0].screenX;
    this.touchstartY = event.changedTouches[0].screenY;
  }

  onTouchEnd(event) {
    this.touchendX = event.changedTouches[0].screenX;
    this.touchendY = event.changedTouches[0].screenY;
    this.handleGesture();
  }

  onNavigateButtonClick(e) {
    const next = e.target.classList.contains(
      "pdp-custom-recommendations__header-next"
    );
    console.log("e", e);

    this.navigate(next);
  }

  navigate(next) {
    if (this.navigating) {
      return;
    }

    const items = this.getItems();
    const activeIndex = this.getActiveIndex();

    if (next && activeIndex < items.length - 1) {
      items[activeIndex].classList.remove("active");
      items[activeIndex + 1].classList.add("active");
    } else if (!next && activeIndex > 0) {
      items[activeIndex].classList.remove("active");
      items[activeIndex - 1].classList.add("active");
    }

    this.navigating = true;
    setTimeout(() => {
      this.navigating = false;
    }, 450);
  }

  getItems() {
    return this.querySelectorAll(".pdp-custom-recommendations__item");
  }

  getActiveIndex() {
    let index = 0;
    this.getItems().forEach((item, i) => {
      if (item.classList.contains("active")) {
        index = i;
      }
    });
    return index;
  }
};

if (!window.customElements.get("custom-product-recommendations")) {
  window.customElements.define(
    "custom-product-recommendations",
    CustomProductRecommendations
  );
}

/* ii: removed dead Reviews.io widget code (app not linked) */

document.addEventListener("DOMContentLoaded", function () {
  // Remove dev section-id labels outside the theme editor. Shopify.designMode is
  // true only inside the customizer; robust replacement for the old hardcoded
  // admin-URL string-match (which broke on newer editor URLs). 2026-07-10.
  if (!window.Shopify || !window.Shopify.designMode) {
    var labels = document.querySelectorAll(".section-id-label");
    labels.forEach(function (label) {
      label.remove();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const dataLayerLength = window.dataLayer.length;
    setInterval(() => {
      if (window.dataLayer.length > dataLayerLength) {
        const consentChanges = window.dataLayer.filter(
          (item) => item[0] === "consent" && item[1] === "update"
        );
        if (consentChanges.length < 2) return;
        let consent = consentChanges[0][2];
        if (consentChanges.length > 2) {
          consent = consentChanges[consentChanges.length - 2][2];
        }

        const updatedConsent = consentChanges[consentChanges.length - 1][2];
        let anyRetract = false;
        Object.keys(consent).forEach((key) => {
          if (updatedConsent[key] !== "granted" && consent[key] === "granted") {
            anyRetract = true;
          }
        });
        if (anyRetract) {
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }
      }
    }, 500);
  }, 3000);
});

/* ------------------------------------------------
   BMSM (Buy More Save More) progress bar preservation.
   The theme's product-rerender replaces the payment-terms block,
   destroying the BMSM content injected by the Boomgate app.
   We save it before rerender and restore it after.
------------------------------------------------- */
(function () {
  document.addEventListener(
    "product:rerender",
    function () {
      var bmsm = document.getElementById("bmsm-productPageBlock");
      if (!bmsm) return;
      window.__bmsmSaved = bmsm;
      bmsm.remove();
      setTimeout(function () {
        if (!window.__bmsmSaved) return;
        var target = document.querySelector("[data-block-type='payment-terms'] payment-terms form");
        if (target && !document.getElementById("bmsm-productPageBlock")) {
          target.prepend(window.__bmsmSaved);
        }
        window.__bmsmSaved = null;
      }, 0);
    },
    true
  );
})();

/* ------------------------------------------------
   Klaviyo BIS (Back-In-Stock) button visibility
   on variant change.
   Uses a CSS class on <body> instead of manipulating
   the Klaviyo container directly, so Klaviyo's own
   DOM management is never disrupted.
   - Hide when variant is discontinued (Auslauf/Expired)
   - Show otherwise (Klaviyo handles available vs OOS)
------------------------------------------------- */
(function () {
  function updateKlaviyoBisVisibility(variant) {
    const variantId = variant?.id;
    const metafields = window.productVariantMetafields?.[variantId];
    const isAvailable =
      metafields?.available ?? variant?.available ?? true;
    const productStat = metafields?.ATTR_Product_Stat?.value || "";
    const isDiscontinued =
      productStat === "Auslauf" || productStat === "Expired";

    if (!isAvailable && isDiscontinued) {
      // Discontinued → hide Klaviyo BIS button via body class
      document.body.classList.add("klaviyo-bis-hidden");
    } else {
      // Available or out-of-stock (not discontinued) → let Klaviyo manage visibility
      document.body.classList.remove("klaviyo-bis-hidden");
    }
  }

  // Listen for variant:change on all product forms
  document.addEventListener("variant:change", function (event) {
    updateKlaviyoBisVisibility(event.detail.variant);
  });
})();

/* A11y: Allow Enter key to toggle checkboxes/radios (screen reader support) */
document.addEventListener("keydown", function (e) {
  if (e.key !== "Enter") return;
  if (e.target.matches('input[type="checkbox"]')) {
    e.preventDefault();
    e.target.checked = !e.target.checked;
    e.target.dispatchEvent(new Event("change", { bubbles: true }));
  } else if (e.target.matches('input[type="radio"]') && !e.target.checked) {
    e.preventDefault();
    e.target.checked = true;
    e.target.dispatchEvent(new Event("change", { bubbles: true }));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Prüfen ob wir auf der Cart-Seite sind
  if (window.location.pathname === "/cart") {
    const style = document.createElement("style");
    style.innerHTML = `
      .bmsm-cart-drawer-block {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const announcementBar = document.querySelector(".bmsm-stickyannouncementbar");

  if (
    window.location.pathname.includes("/pages/store-locator") ||
    window.location.pathname.includes("/pages/stores/")
  ) {
    const style = document.createElement("style");
    style.innerHTML = `
    .bmsm-stickyannouncementbar {
      display: none !important;
    }
  `;
    document.head.appendChild(style);
  }
  // Ansonsten normale Funktionalität
  else if (announcementBar) {
    const style = document.createElement("style");
    style.innerHTML = `
      .facets__floating-filter {
        transform: translateY(-60px) !important;
      }
    `;
    document.head.appendChild(style);
  }
});

/* ------------------------------------------------
   Keyboard accessibility: ensure wishlist buttons
   (Swish/Wishlist King) are reachable via Tab
------------------------------------------------- */
(function () {
  function fixWishlistButtons() {
    // Target .wk-button by class (newer Wishlist King SDK renders
    // <div class="wk-button"> inside <wishlist-button-*> wrappers)
    document.querySelectorAll(".wk-button").forEach(function (el) {
      if (el.tagName === "BUTTON" || el.tagName === "A") return;
      if (!el.hasAttribute("tabindex")) {
        el.setAttribute("tabindex", "0");
      }
      if (!el.hasAttribute("role")) {
        el.setAttribute("role", "button");
      }
      // Allow keyboard activation with Enter and Space
      if (!el._wkKeyHandler) {
        el._wkKeyHandler = true;
        el.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            el.click();
          }
        });
      }
    });

    // Also handle <wk-button> custom element tag (older SDK)
    document.querySelectorAll("wk-button").forEach(function (wkBtn) {
      var btn = wkBtn.querySelector("button");
      if (btn && btn.tabIndex < 0) {
        btn.tabIndex = 0;
      }
      if (!btn && wkBtn.shadowRoot) {
        btn = wkBtn.shadowRoot.querySelector("button");
        if (btn && btn.tabIndex < 0) {
          btn.tabIndex = 0;
        }
      }
    });
  }

  // Run once when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixWishlistButtons);
  } else {
    fixWishlistButtons();
  }

  // Re-run when new wishlist buttons are injected dynamically
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        fixWishlistButtons();
        break;
      }
    }
  });
  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();


/* Footer payment-methods group — upgrade-safe: relocates the stock
   payment-icons list (rendered in the footer aside when show_payment_icons
   is on) into a block-list group titled お支払い方法, matching the US/German
   footer. No-ops when the stock markup changes or no payment types are
   enabled (icons then stay in the stock aside position). */
(function () {
  function relocatePaymentIcons() {
    var list = document.querySelector('.footer__block-list');
    var icons = document.querySelector('.footer__aside .footer__payment-icons');
    if (!list || !icons || !icons.children.length) return;
    if (document.querySelector('.footer__block--payment')) return;
    var block = document.createElement('div');
    block.className = 'footer__block footer__block--menu footer__block--payment';
    var title = document.createElement('p');
    title.className = 'bold';
    title.textContent = 'お支払い方法';
    block.appendChild(title);
    block.appendChild(icons);
    list.appendChild(block);
  }
  if (document.readyState !== 'loading') relocatePaymentIcons();
  else document.addEventListener('DOMContentLoaded', relocatePaymentIcons);
})();

/* Footer mobile accordion — upgrade-safe (operates on stock footer.liquid markup) */
(function () {
  function initFooterAccordion() {
    var isMobile = window.matchMedia('(max-width: 1150px)').matches; /* 1150 must match the accordion @media in custom.css (line ~296). Was 999 -> links were hidden 1000-1150px with no toggle bound. 2026-07-17 */
    var blocks = document.querySelectorAll('.footer__block--menu');
    for (var i = 0; i < blocks.length; i++) {
      (function (block) {
        var title = block.querySelector('p') || block.querySelector('.heading');
        if (!title) return;
        if (isMobile) {
          if (!title.dataset.faBound) {
            title.dataset.faBound = '1';
            title.addEventListener('click', function () { block.classList.toggle('is-open'); });
          }
        } else {
          block.classList.remove('is-open');
        }
      })(blocks[i]);
    }
  }
  if (document.readyState !== 'loading') initFooterAccordion();
  else document.addEventListener('DOMContentLoaded', initFooterAccordion);
  window.addEventListener('resize', initFooterAccordion);
})();


/* Featured-articles slider — auto-advance (homepage). CSS makes .blog-post-list__posts a
   scroll-snap flex track; this steps it card-by-card, loops, and pauses on hover/touch.
   Respects prefers-reduced-motion (no auto-advance; manual swipe/scroll still works). */
(function () {
  function initFeaturedSlider() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tracks = document.querySelectorAll('.shopify-section--featured-articles .blog-post-list__posts');
    for (var t = 0; t < tracks.length; t++) {
      (function (track) {
        if (track.dataset.faSlider) return;
        track.dataset.faSlider = '1';
        var items = track.children;
        if (items.length < 2) return;
        function step() {
          var w = items[0].getBoundingClientRect().width;
          var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '24') || 24;
          return w + gap;
        }
        var timer = null, idx = 0;
        function advance() {
          var maxScroll = track.scrollWidth - track.clientWidth;
          idx += 1;
          var target = idx * step();
          if (target > maxScroll + 4) { idx = 0; target = 0; }
          track.scrollTo({ left: target, behavior: 'smooth' });
        }
        function start() { if (reduce) return; stop(); timer = setInterval(advance, 4500); }
        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        track.addEventListener('mouseenter', stop);
        track.addEventListener('mouseleave', start);
        track.addEventListener('touchstart', stop, { passive: true });
        var st;
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () { idx = Math.round(track.scrollLeft / step()); }, 160);
        }, { passive: true });
        start();
      })(tracks[t]);
    }
  }
  if (document.readyState !== 'loading') initFeaturedSlider();
  else document.addEventListener('DOMContentLoaded', initFeaturedSlider);
})();
